// Library methods
import { useTranslation } from "react-i18next";

// MUI Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DefaultModal from "../DefaultModal";

// Styles
import {
  ModalCustomCancel,
  ModalCustomConfirm,
} from "../../../styles/muiStylesHelper";

const SharedConfirmation = ({
  open,
  onClose,
  onConfirm,
  onCancel,
  loading,
  title,
  description,
  confirmationButtonText,
  cancelText = "button_cancel",
}) => {
  // internationalization
  const { t } = useTranslation();

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      title={t(title)}
      maxWidth="xs"
      modalActions={
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          <Button variant="text" sx={ModalCustomCancel} onClick={onCancel}>
            {t(cancelText)}
          </Button>
          <Button
            variant="outlined"
            disabled={loading}
            sx={ModalCustomConfirm}
            onClick={onConfirm}
          >
            {t(confirmationButtonText)}
          </Button>
        </Grid>
      }
    >
      <Grid display="flex" flexDirection="column" p="20px" gap="20px">
        <Typography id="modal-modal-description">{t(description)}</Typography>
      </Grid>
    </DefaultModal>
  );
};

export default SharedConfirmation;
